import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ab50d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid invoice-form" }
const _hoisted_2 = { class: "grid-col-xs-12 grid-col-md-6 form-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "mb-4 mt-3" }, "Crear factura de venta!", -1))
const _hoisted_4 = { class: "mb-3 form-field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "normal mb-1"
}, "Fecha:", -1))
const _hoisted_6 = { class: "mb-3 form-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "dueDate",
  class: "normal mb-1"
}, "Fecha de venta:", -1))
const _hoisted_8 = { class: "mb-3 form-field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "clientId",
  class: "normal mb-1"
}, "Id Cliente:", -1))
const _hoisted_10 = { class: "mb-3 form-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "productId",
  class: "normal mb-1"
}, "Id Producto:", -1))
const _hoisted_12 = { class: "mb-3 form-field" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "total",
  class: "normal mb-1"
}, "Total:", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary my-3"
}, " Crear factura ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("article", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmitFormData && _ctx.handleSubmitFormData(...args)), ["prevent"])),
        class: "form-container"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.date) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.formData.date]
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "date",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.dueDate) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.formData.dueDate]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.client) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.formData.client]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.productId) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.formData.productId]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            type: "number",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.total) = $event)),
            required: ""
          }, null, 512), [
            [_vModelText, _ctx.formData.total]
          ])
        ]),
        _hoisted_14
      ], 32)
    ])
  ]))
}